<header class="c-header {{#if additionalClasses}}{{additionalClasses}}{{/if}}">
	<nav class="navbar navbar-default navbar-filled">
		<div class="container-fluid container-mw">
			<div class="navbar-header">
				<a class="main-logo" href="/" on-click="@this.fire('main-logo-click')">
					<!--
						Looking for the logo?
						Get all versions here: https://github.com/jsdelivr/globalping-media
					-->
					{{#if mainLogoName}}
						<img width="138" height="34" src="{{@shared.assetsHost}}/img/globalping/{{mainLogoName}}" title="Globalping">
					{{else}}
						<img width="138" height="34" src="{{@shared.assetsHost}}/img/globalping/globalping.svg" title="Globalping">
					{{/if}}
				</a>

				<a class="main-logo_text globalping" href="https://www.jsdelivr.com">by jsDelivr</a>

				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#main-navbar" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
			</div>

			<div class="collapse navbar-collapse" id="main-navbar">
				<ul class="nav navbar-nav navbar-right {{!actualPath ? 'navbar-hidden' : 'about-navbar-right'}}">
					<li><a href="/cli">CLI</a></li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
							Integrations <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a href="/slack">Slack App</a></li>
							<li><a href="https://github.com/globalping" target="_blank">GitHub Bot <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
							<li><a href="/docs/api.globalping.io" class="router-ignore">REST API</a></li>
							<li role="separator" class="divider"></li>
							<li><a href="/integrations">All Integrations</a></li>
						</ul>
					</li>
					<li><a href="/credits">Credits</a></li>
					<li><a href="/network">Network</a></li>
					<li><a href="/sponsors">Sponsors</a></li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
							The Project <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a href="/about-us">About Us</a></li>
							<li role="separator" class="divider"></li>
							<li><a target="_blank" href="https://blog.globalping.io" class="router-ignore">Blog <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
							<li><a target="_blank" href="https://github.com/jsdelivr/globalping" class="router-ignore">GitHub <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
							<li><a target="_blank" rel="noopener noreferrer" href="https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736">Newsletter <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
						</ul>
					</li>
					<li>
						<a target="_blank" rel="noopener noreferrer" href="https://twitter.com/jsDelivr" title="Twitter">
							<i class="fa fa-twitter" aria-hidden="true"></i>
							<span class="icon-label-mobile">Twitter</span>
						</a>
					</li>
					{{#if @shared.user}}
						<li class="dashboard-section">
							<a href="https://dash.globalping.io" class="btn btn-dash">
								<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
									<path d="M8.33333 2.5H2.5V8.33333H8.33333V2.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M17.5 2.5H11.6667V8.33333H17.5V2.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M17.5 11.6667H11.6667V17.5001H17.5V11.6667Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M8.33333 11.6667H2.5V17.5001H8.33333V11.6667Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg> Dashboard
							</a>

							<div class="dropdown">
								<button type="button" class="btn dropdown-toggle hidden-xs hidden-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<svg style="vertical-align: middle;" fill="currentColor" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<g id="user"><path d="M12,12.25A3.75,3.75,0,1,1,15.75,8.5,3.75,3.75,0,0,1,12,12.25Zm0-6A2.25,2.25,0,1,0,14.25,8.5,2.25,2.25,0,0,0,12,6.25Z"/>
											<path d="M19,19.25a.76.76,0,0,1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25,1.3-6.25,3.25a.75.75,0,0,1-1.5,0c0-4.75,5.43-4.75,7.75-4.75s7.75,0,7.75,4.75A.76.76,0,0,1,19,19.25Z"/>
										</g>
									</svg>
									<span class="caret"></span>
									<span class="sr-only">Toggle Dropdown</span>
								</button>
								<ul class="dropdown-menu">
									<li class="current-user">{{@shared.user.github_username}}</li>
									<li role="separator" class="divider"></li>
									<li><a on-click="@this.signOut()">Sign Out</a></li>
								</ul>
							</div>
						</li>
						<li class="hidden-md hidden-lg"><a on-click="@this.signOut()"><i class="fa fa-sign-out" style="margin-right: 8px;"></i>Sign Out</a></li>
					{{elseif @shared.user === null}}
						<li class="dashboard-section">
							<a class="btn btn-sign-in" on-click="@this.signIn()">
								<i class="fa fa-sign-in hidden-md hidden-lg" style="margin-right: 8px;"></i>
								Sign in
								<span class="hidden-md hidden-lg">&nbsp;with GitHub</span><i class="fa fa-github hidden-xs hidden-sm" style="margin-left: 8px;"></i>
							</a>
						</li>
					{{else}}
						<li class="dashboard-section"></li>
					{{/if}}
				</ul>
			</div>
		</div>
	</nav>
</header>

<script>
	const http = require('../../assets/js/utils/http');

	component.exports = {
		data () {
			return {};
		},
		oninit () {
			if (Ractive.isServer) {
				this.set('actualPath', this.root.get('actualPath'));
			} else {
				this.set('actualPath', this.get('@shared')?.app?.router?.uri?.path);
			}
		},
		signIn () {
			let url = new URL('https://dash-directus.globalping.io/auth/login/github');
			url.searchParams.set('redirect', `${this.get('@shared.serverHost')}/auth/callback?redirect=${encodeURIComponent(location.href)}`);
			location.href = url.toString();
		},
		signOut () {
			http.gpLogOut().then(() => this.set('@shared.user', null));
		},
	};
</script>
